import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import uploadIcon from '../../img/upload-file.png';
import fileIcon from '../../img/file-icon.png';
import '../../css/ActiveClaims.css';
import '../../css/AdjustmentsActiveClaims.css';
import MainWrapper from '../wrappers/mainWrapper';
import Joyride from 'react-joyride';
import '../../css/joyride-overrides.css';
import CustomBeacon from './CustomBeacon';

const MAX_COUNT = 2;
export const comparisonState = false;

const CreateNewClaim = props => {
    const [customName1, setCustomName1] = useState("Doc1");
    const [customName2, setCustomName2] = useState("Doc2");
    const isMounted = useRef(false);
    const [runTour, setRunTour] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const [showBeacon, setShowBeacon] = useState(false);

    const fileInputRef = useRef(null);
    const [claimData, setClaimData] = useState({
        adj_email: "",
        adj_phone: "",
        adjuster: "",
        claim_number: "",
        claim_type: "",
        date_open: "",
        insurance_comp: "",
        status: "",
        insured: "",
        insured_address: "",
        insured_phone: "",
        prop_type: "",
        user_id: "",
        doc1_name: customName1 || "",
        doc2_name: customName2 || ""
    });

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (claimData.doc1_name !== customName1 || claimData.doc2_name !== customName2) {
                setClaimData(prev => ({
                    ...prev,
                    doc1_name: customName1 || "",
                    doc2_name: customName2 || ""
                }));
            }
        }, 1000);
        return () => clearTimeout(timeout);
    }, [customName1, customName2, claimData]);

    let path = `/activeClaims`;
    const navigate = useNavigate();
    const [responded, setResponded] = useState(false);
    const buttonRef = useRef(null);
    const userData = useSelector(state => state.user._id);
    const [file1Name, setFile1Name] = useState("");
    const [file2Name, setFile2Name] = useState("");
    const [modalData, setModalData] = useState({
        header1: { name:'', count:'' },
        header2: { name:'', count:'' }
    });

    const getComparisons = async (page = 1) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_GET_COMPARISONS}${userData}?page=${page}&limit=10`
            );
            const data = await response.json();
            console.log("data: ", data);
    
            if (!data.comparisons || data.comparisons.length === 0) {
                // No comparisons, start walkthrough automatically
                console.log("No comparisons: starting tour");
                setRunTour(true);      // auto-run tour
                setShowBeacon(true);   // still show beacon
            } else {
                // Comparisons exist, only show beacon
                console.log("Comparisons exist: showing beacon only");
                setRunTour(true);     // do not auto-run
                setShowBeacon(false);   // show beacon so user can start tour
            }
        } catch (error) {
            console.error('Error fetching comparisons:', error);
            setRunTour(true); 
            setShowBeacon(true); // fallback: show beacon + tour
        }
    };
    

    useEffect(() => {
        getComparisons();
    }, []);

    const [loadingStatus, setLoadingStatus] = useState('');
    const [numberOfSubmits, setNumberOfSubmits] = useState(0);
    const [fileUploaded, setFileUploaded] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileLimit, setFileLimit] = useState(false);
    const [pdfs, setPdfs] = useState([]);
    const [pdfError, setPdfError] = useState(null);

    const fetchPdfs = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LIST_PDFS}/${userData}`);
            setPdfs(response.data.pdfs); // assuming the response has a `pdfs` array
        } catch (err) {
            console.error(err);
            setPdfError('Error loading PDFs');
        }
    };

    useEffect(() => {
        setClaimData({
            ...claimData,
            user_id: userData
        });
        renderForm1();
        returnFile();
    }, [responded]);

    const handleChange = e => {
        newClaim();
        setClaimData({ ...claimData, [e.target.name]: e.target.value });
    };

    const newClaim = () => {
        localStorage.setItem('user', '');
        setClaimData({ ...claimData, user_id: userData });
        setClaimData({ ...claimData, file1Name: file1Name });
        setClaimData({ ...claimData, file2Name: file2Name });
        setModalData({ ...modalData, claimData: { ...claimData, file1Name: file1Name[0], file2Name: file2Name[0] } });
    };

    const steps = [
        { target: '#insured', content: 'Enter the name of the insured here.', placement: 'right' },
        { target: '#insured_address', content: 'Enter the insured address here.' },
        { target: '#claim_number', content: 'Add the claim number.' },
        { target: '#adjuster', content: 'Optionally enter the adjuster’s name.' },
        { target: '.button-upload:first-of-type', content: 'Upload your first file here.' },
        { target: '.button-upload:nth-of-type(2)', content: 'Upload your second file here.' },
        { target: '.button-submit-comparison', content: 'Finally, submit your comparison.', placement: 'left' }
    ];

    function verifyResponse(x) { return x || ""; }

    function returnFile() {
        if(uploadedFiles.length === 2) {
            setFile1Name(uploadedFiles.slice(0,1).map((key) => key.name));
            setFile2Name(uploadedFiles.slice(1,2).map((key) => key.name));
        }
    }

    const newComparison = async (e) => {
        e.preventDefault();
        if (numberOfSubmits > 0) return;
        setNumberOfSubmits(1);
        setLoadingStatus('loading-spinner');

        let uploaded = [];
        let skipped = [];

        if (!fileUploaded && uploadedFiles.length > 0) {
            try {
                const formData = new FormData();
                uploadedFiles.forEach((file) => {
                    formData.append("file", file);
                });
                formData.append("doc1_name", uploadedFiles[0]?.customName || customName1);
                formData.append("doc2_name", uploadedFiles[1]?.customName || customName2);
                formData.append("userId", userData);
                const uploadResponse = await fetch(`${process.env.REACT_APP_POST_FILES}`, {
                    method: "POST",
                    body: formData,
                });
                const uploadResult = await uploadResponse.json();
                uploaded = uploadResult.uploaded || [];
                skipped = uploadResult.skipped || [];
                setFileUploaded(true);
            } catch (error) {
                console.error("❌ Upload failed:", error);
                alert("Failed to upload your files.");
                setLoadingStatus('');
                setNumberOfSubmits(0);
                return;
            }
        }

        newClaim();
        navigate(path);

        const updatedModalData = {
            ...modalData,
            claimData: {
                ...modalData.claimData,
                ...claimData,
                doc1_name: uploadedFiles[0]?.customName || customName1,
                doc2_name: uploadedFiles[1]?.customName || customName2,
            },
            files: {
                file_1: uploaded[0] || uploadedFiles[0]?.name || "Unknown File 1",
                file_2: uploaded[1] || uploadedFiles[1]?.name || "Unknown File 2",
            },
            timeout: 10000000,
        };

        axios.post(`${process.env.REACT_APP_QUEUE}`, updatedModalData)
            .then((response) => {
                if (!isMounted.current) return;
                setLoadingStatus('');
                if (response.data["code"] !== 200) {
                    console.error("=====================================");
                    console.error("ERROR CODE: " + response.data["code"]);
                    console.error("=====================================");
                }
                const data = response.data.data[0];
                setComparisonID(verifyResponse(data.comparisonID));
                setModifyHeadersOpen1(true);
                setResponded(true);
            })
            .catch((error) => {
                console.error("❌ Queue submission failed:", error);
                if (!isMounted.current) return;
                setLoadingStatus('');
                setNumberOfSubmits(0);
                navigate(path);
            });
    };

    const handleUploadFiles = (files) => {
        const uploaded = [...uploadedFiles];
        let limitExceeded = false;
        files.forEach((file) => {
            if (uploaded.findIndex((f) => f.name === file.name) === -1) {
                const customName = window.prompt(`Enter a name for ${file.name}:`, file.name) || file.name;
                const fileWithCustomName = new File([file], file.name, { type: file.type });
                fileWithCustomName.customName = customName;
                uploaded.push(fileWithCustomName);
                if (uploaded.length === 1) setCustomName1(customName);
                else if (uploaded.length === 2) setCustomName2(customName);
                if (uploaded.length === MAX_COUNT) setFileLimit(true);
                if (uploaded.length > MAX_COUNT) {
                    alert(`You can only add a maximum of ${MAX_COUNT} files`);
                    setFileLimit(false);
                    limitExceeded = true;
                    return true;
                }
            }
        });
        if (!limitExceeded) setUploadedFiles(uploaded);
    };

    const handleFileEvent = (e) => {
        const chosenFiles = Array.prototype.slice.call(e.target.files);
        handleUploadFiles(chosenFiles);
    };

    function file1DefaultText() {
        if (uploadedFiles.length === 0) return <p style={defaultText}>Select File #1</p>;
        return (
            <label htmlFor='fileUpload' className='upload-new-file-button' onClick={resetArray}>
                + Upload New File
            </label>
        );
    }

    function file2DefaultText() {
        if (uploadedFiles.length < 2) return <p style={defaultText}>Select File #2</p>;
        return (
            <label htmlFor='fileUpload' className='upload-new-file-button' onClick={resetArray}>
                + Upload New File
            </label>
        );
    }

    function allowSubmitComparisonButton() {
        const hasFiles = uploadedFiles.length === 2;
        const isProcessing = numberOfSubmits > 0;
        return isProcessing || !hasFiles
            ? 'button-submit-comparison-disabled'
            : 'button-submit-comparison';
    }

    function toggleImg1() {
        return uploadedFiles.length >= 1 ? fileIcon : uploadIcon;
    }

    function toggleImg2() {
        return uploadedFiles.length === 2 ? fileIcon : uploadIcon;
    }

    function resetArray() {
        if (window.confirm('Do you wish to remove both files from the session?')) {
            setUploadedFiles([]);
            setCustomName1("Doc1");
            setCustomName2("Doc2");
            setFileLimit(false);
            if (fileInputRef.current) fileInputRef.current.value = null;
        }
    }

    function renderForm1() {
        return (
            <div className={"create-new-claim-container"}>
                <h1 className={'h1-create-new-claim'}>Create New Comparison</h1>
                <form className={'form-layout'} onSubmit={(e) => newClaim(e)}>
                    <div className={'form-element-style'}>
                        <label className={'create-new-claim-label'} htmlFor="insured">Insured<span style={optionalField}>(optional)</span></label>
                        <input className={'create-new-claim-input'} type="text" id="insured" name="insured" placeholder="Insured Name" onChange={handleChange}/>
                    </div>
                    <div className={'form-element-style'}>
                        <label className={'create-new-claim-label'} htmlFor="insured-address">Insured Address <span style={optionalField}>(optional)</span></label>
                        <input className={'create-new-claim-input'} type="text" id="insured_address" name="insured_address" placeholder="Insured Address" onChange={handleChange}/>
                    </div>
                    <div className={'form-element-style'}>
                        <label className={'create-new-claim-label'} htmlFor="claim-number">Claim Number <span style={optionalField}>(optional)</span></label>
                        <input className={'create-new-claim-input'} type="text" id="claim_number" name="claim_number" placeholder="Claim Number" onChange={handleChange}/>
                    </div>
                    <div className={'form-element-style'}>
                        <label className={'create-new-claim-label'} htmlFor="adjuster">Adjuster <span style={optionalField}>(optional)</span></label>
                        <input className={'create-new-claim-input'} type="text" id="adjuster" name="adjuster" placeholder="Adjuster Name" onChange={handleChange}/>
                    </div>
                    <div style={lineBreak}><div></div></div>
                    <div style={lineBreak}><div></div></div>
                    <div className="hiddenFieldName" style={{display: 'none'}} type="text" name="user_id" id="user_id" value={userData}/>             
                </form>

                <h2 className={'h2-upload-comparison'}>Upload Comparison</h2>
                <form className={'file-upload'}>
                    <input
                        style={{ display: 'none' }}
                        id="fileUpload"
                        type="file"
                        multiple
                        accept="application/pdf, image/png"
                        onChange={handleFileEvent}
                        disabled={fileLimit}
                        ref={fileInputRef}
                    />

                    <label style={file1} className={!fileLimit ? 'button-upload' : 'button-upload-disabled'} htmlFor='fileUpload'>
                        <img style={imgResize} src={toggleImg1()}></img>
                        <div style={fileInfo}>
                            {uploadedFiles.slice(0, 1).map((file, index) => (
                                <p key={file.name || index} id={index} className="uploaded-files-name">{file.name}</p>
                            ))}
                            {file1DefaultText()}
                        </div>
                    </label>

                    <label style={file2} className="button-upload" aria-disabled={fileLimit ? 'true' : 'false'} htmlFor='fileUpload'>
                        <img style={imgResize} src={toggleImg2()}></img>
                        <div style={fileInfo}>
                            {uploadedFiles.slice(1, 2).map((file, index) => (
                                <p key={file.name || index} className="uploaded-files-name">{file.name}</p>
                            ))}
                            {file2DefaultText()}
                            <br/>
                        </div>
                    </label>
                </form>

                <form className={'buttons-container'} onSubmit={(e) => newComparison(e)}>
                    <div className="submit-comparison-container" style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                        <button 
                            type="submit" 
                            ref={buttonRef}
                            className={`button-submit-comparison ${allowSubmitComparisonButton()}`}
                            style={{
                                backgroundColor: numberOfSubmits > 0 ? 'gray' : (allowSubmitComparisonButton() === 'button-submit-comparison' ? '#00B3B5' : '#cccccc'), 
                                color: 'white', 
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '4px'
                            }}
                            disabled={numberOfSubmits > 0 || allowSubmitComparisonButton() === 'button-submit-comparison-disabled'}
                        >
                            {numberOfSubmits > 0 ? 'Processing...' : 'Upload Files & Submit Comparison'}
                        </button>  
                    </div>
                </form>

                {pdfError && <p style={{ color: 'red' }}>{pdfError}</p>}
                <ul>
                    {pdfs.map((pdf, idx) => (
                        <li key={idx}>{pdf}</li>
                    ))}
                </ul>
            </div>
        );
    }

    const optionalField = { color: '#777777', fontWeight: '400' };
    const file1 = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        borderRadius: '8px',
        width: '45%',
        height: '220px',
        marginRight: '32px'
    };
    const file2 = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        width: '45%',
        height: '220px',
        borderRadius: '8px',
        marginLeft: '32px'
    };
    const fileInfo = {
        fontSize: '2.0vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '14px',
        width: '100%',
        textAlign: 'center'
    };
    const defaultText = { color: '#333333', fontWeight: 'bold', fontSize: '1.5vh' };
    const imgResize = { height: 'auto', width: '13%', minWidth: '56px', margin: '0 auto' };
    const lineBreak = { width: '100%', height: '40px' };

    return (
        <div className={'outer-container'}>
            <MainWrapper/>
            <Joyride
                steps={steps.map(step => ({
                    ...step,
                    // disable beacon only if tour is auto-running (no comparisons)
                    disableBeacon: showBeacon
                }))}
                run={runTour} 
                stepIndex={stepIndex}
                continuous
                showSkipButton
                showProgress
                showBackButton={false}
                scrollToFirstStep
                spotlightClicks={true}
                disableOverlayClose={true}
                beaconComponent={CustomBeacon}
                styles={{ options: { zIndex: 10000 } }}
                callback={(data) => {
                    const { status, index, type, step } = data;

                    if (['finished', 'skipped'].includes(status)) {
                        setStepIndex(0);
                        setRunTour(false); // stop tour after finishing
                    } else if (type === 'step:after') {
                        setStepIndex(index + 1);
                    } else if (type === 'step:before') {
                        const el = document.querySelector(step.target);
                        if (el && typeof el.focus === 'function') el.focus();
                    }
                }}
            />
            <div className={loadingStatus}></div>
            <div className={'right-container'}>
                {renderForm1()}  
            </div>                
        </div>
    );
};

export default CreateNewClaim;
